export default "__VITE_ASSET__QIIe$TdE__"